export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7500.e81370b5.jpg";